import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form } from "semantic-ui-react";
import { TitleCase } from "../../common";

class LabelArea extends Component {
  shouldComponentUpdate(nextProps) {
    const different = this.props.element_value !== nextProps.element_value;
    return different;
  }

  replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, "g"), replace);
  }

  createMarkup(val) {
    return {
      __html: this.replaceAll(
        val,
        "<a ",
        '<a style="text-decoration: underline;"'
      )
    };
  }

  render() {
    const { element_prompt, element_value, ...formControl } = this.props;
    let text = formControl.element_params.T;
    return (
      <div className="formControlItem">
        <Form.Field>
          <label style={{ fontWeight: "bold" }}>
            {TitleCase(element_prompt)}
            <span className="optionalField"></span>
          </label>
          <div
            dangerouslySetInnerHTML={this.createMarkup(text)}
            style={{ fontSize: "13px" }}
          ></div>
        </Form.Field>
      </div>
    );
  }
}

LabelArea.propTypes = {
  element_prompt: PropTypes.string.isRequired,
  element_value: PropTypes.string.isRequired
};

export default LabelArea;



// WEBPACK FOOTER //
// ./src/components/LabelArea/index.js